import { BoltIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';

import { CommandCenterStats as CommandCenterStatsType } from '@/types/enhanced-bland-call';

interface CommandCenterStatsProps {
  stats: CommandCenterStatsType;
  onTriggerMassScheduler: () => void;
}

export const CommandCenterStats: React.FC<CommandCenterStatsProps> = ({
  stats,
  onTriggerMassScheduler,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleMassScheduleClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmMassSchedule = () => {
    setShowConfirmModal(false);
    onTriggerMassScheduler();
  };

  return (
    <>
      <div className="bg-gray-50 border-b border-gray-200 px-3 py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4 text-xs text-gray-600">
            <span>
              Matters:{' '}
              <span className="text-gray-900 font-medium">
                {stats.matters_with_activity}
              </span>
            </span>
            <span>
              Calls:{' '}
              <span className="text-gray-900 font-medium">
                {stats.total_calls}
              </span>
            </span>
            <span>
              Scheduled:{' '}
              <span className="text-gray-900 font-medium">
                {stats.scheduled_runs}
              </span>
            </span>
            <span>
              Overdue:{' '}
              <span className="text-gray-900 font-medium">
                {stats.overdue_runs}
              </span>
            </span>
            <span>
              Cost:{' '}
              <span className="text-gray-900 font-medium">
                ${stats.total_cost_usd?.toFixed(2) || '0.00'}
              </span>
            </span>
            <span className="text-gray-300">•</span>
            <span>24h: {stats.recent_calls_24h}</span>
            <span>Active: {stats.active_runs}</span>
            <span>Runs: {stats.total_runs}</span>
          </div>

          <button
            type="button"
            onClick={handleMassScheduleClick}
            className="flex items-center gap-1 px-2 py-1 text-xs text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded transition-colors"
          >
            <BoltIcon className="h-3 w-3" />
            Mass Schedule
          </button>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50">
          <div className="bg-white rounded shadow-lg max-w-sm w-full mx-4">
            <div className="flex items-center justify-between p-4 border-b border-gray-100">
              <h3 className="text-sm font-medium text-gray-900">
                Mass Schedule Confirmation
              </h3>
              <button
                type="button"
                onClick={() => setShowConfirmModal(false)}
                className="p-1 hover:bg-gray-50 rounded text-gray-400 hover:text-gray-600"
              >
                <XMarkIcon className="h-4 w-4" />
              </button>
            </div>
            <div className="p-4">
              <p className="text-xs text-gray-600 mb-3">
                Trigger mass police scheduler across all eligible matters. This
                will schedule voice agent runs for police report collection.
              </p>
              <div className="bg-gray-50 rounded p-3 mb-3">
                <p className="text-xs text-gray-700">
                  This is a system-wide operation that may schedule many runs
                  simultaneously.
                </p>
              </div>
            </div>
            <div className="flex items-center justify-end gap-2 p-4 border-t border-gray-100">
              <button
                type="button"
                onClick={() => setShowConfirmModal(false)}
                className="px-3 py-1 text-xs text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConfirmMassSchedule}
                className="px-3 py-1 text-xs text-white bg-gray-900 hover:bg-gray-800 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
